import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import Navigation from '../components/Navigation';
import { toast } from 'react-toastify';

function Income() {
  const [summary, setSummary] = useState(null);
  const [gift, setGift] = useState(null);
  const [passive, setPassive] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchAll();
  }, []);

  const fetchAll = async () => {
    try {
      const [sumRes, giftRes, passRes] = await Promise.all([
        api.get('/Income/summary'),
        api.get('/Income/gift/status'),
        api.get('/Income/passive/status'),
      ]);
      setSummary(sumRes.data);
      setGift(giftRes.data);
      setPassive(passRes.data);
    } catch (err) {
      console.log(err);
    }
  };

  const claimGift = async () => {
    setLoading(true);
    try {
      const res = await api.post('/Income/gift/claim');
      toast.success(res.data.message);
      fetchAll();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed');
    } finally {
      setLoading(false);
    }
  };

  const claimPassive = async () => {
    setLoading(true);
    try {
      const res = await api.post('/Income/passive/claim');
      toast.success(res.data.message);
      fetchAll();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 pb-20">
      <div className="bg-indigo-600 text-white p-4">
        <button onClick={() => navigate(-1)} className="text-sm mb-2">← Back</button>
        <h2 className="text-xl font-bold">My Income</h2>
      </div>

      <div className="p-4 space-y-4">
        {/* Total Summary */}
        {summary && (
          <div className="bg-white rounded-2xl p-4 shadow">
            <p className="text-gray-500 text-sm">Total Income</p>
            <p className="text-3xl font-bold text-indigo-600">₹{summary.totalIncome || 0}</p>

            <div className="grid grid-cols-3 gap-2 mt-4 text-center text-sm">
              <div className="bg-blue-50 p-2 rounded-xl">
                <p className="text-gray-500">Level 1</p>
                <p className="font-bold">₹{summary.level1 || 0}</p>
              </div>
              <div className="bg-green-50 p-2 rounded-xl">
                <p className="text-gray-500">Level 2</p>
                <p className="font-bold">₹{summary.level2 || 0}</p>
              </div>
              <div className="bg-purple-50 p-2 rounded-xl">
                <p className="text-gray-500">Level 3</p>
                <p className="font-bold">₹{summary.level3 || 0}</p>
              </div>
            </div>
          </div>
        )}

        {/* Gift Income */}
        {gift && (
          <div className="bg-white rounded-2xl p-4 shadow">
            <h3 className="font-semibold text-gray-700 mb-2">🎁 Gift Income</h3>
            <p className="text-sm text-gray-500 mb-2">{gift.message}</p>
            <div className="flex justify-between text-sm mb-3">
              <span>Members: {gift.directMembers}</span>
              <span>Gifts Claimed: {gift.claimedGifts}</span>
            </div>
            {gift.canClaim && (
              <button
                onClick={claimGift}
                disabled={loading}
                className="w-full bg-pink-500 text-white font-bold py-2 rounded-xl disabled:opacity-50"
              >
                Claim Gift
              </button>
            )}
          </div>
        )}

        {/* Passive Income */}
        {passive && (
          <div className="bg-white rounded-2xl p-4 shadow">
            <h3 className="font-semibold text-gray-700 mb-2">📈 Passive Income</h3>
            <p className="text-sm text-gray-500 mb-2">{passive.message}</p>
            <div className="flex justify-between text-sm mb-3">
              <span>Active Members: {passive.activeMembers}</span>
              <span>Daily: ₹{passive.dailyIncome}</span>
            </div>
            {passive.canClaim && (
              <button
                onClick={claimPassive}
                disabled={loading}
                className="w-full bg-orange-500 text-white font-bold py-2 rounded-xl disabled:opacity-50"
              >
                Claim Today's Passive
              </button>
            )}
          </div>
        )}
      </div>

      <Navigation />
    </div>
  );
}

export default Income;